var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustCaution(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "288px",
    height: "187px",
    viewBox: "0 0 288 187",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_Notify_re_65on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7BA1\\u7406\\u8005\\u753B\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u3010A-07-04-02\\u3011\\u30AF\\u30E9\\u30B9\\u60C5\\u5831\\u30FB\\u30E6\\u30FC\\u30B6\\u30FC\\u60C5\\u5831\\u306E\\u4E0A\\u66F8\\u304D\\u53EF\\u5426\\u9078\\u629E\\u753B\\u9762",
    transform: "translate(-723.000000, -273.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Notify_re_65on",
    transform: "translate(723.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.485747,186 L254,160.709094 C254,160.709094 263.333755,169.927275 263.333755,177.490909 L261.658468,160 C261.658468,160 266.445008,166.381819 265.966353,176.072728 C265.487698,185.763638 262.485747,186 262.485747,186 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.778602,164 L78,139.68182 C78,139.68182 86.5559419,148.545455 86.5559419,155.818184 L85.0202628,139 C85.0202628,139 89.4079261,145.136365 88.9691566,154.454545 C88.5303871,163.772726 85.778602,164 85.778602,164 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,174.240235 C211.013738,190.092482 179.434869,185.216355 140.774939,185.249575 C102.115009,185.282796 71.0137465,190.212773 71,174.360552 C70.9862624,158.50833 102.553578,155.033463 141.213508,155 C179.873438,154.967015 210.986253,158.387988 211,174.240235 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 0,
    y: 186,
    width: 288,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "184 153 179.257116 153 177 133 184 133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.616308,152 L185,152 L185,158 L169,158 L169,157.45112 C169,154.440546 171.514513,152 174.616308,152 L174.616308,152 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "221 182 216.257116 182 214 162 221 162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.616308,181 L223,181 L223,187 L207,187 L207,186.45112 C207,183.440546 209.514513,181 212.616308,181 L212.616308,181 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.14791,123.603459 C245.850065,122.743642 246.138992,121.613932 245.936945,120.51832 C245.734898,119.422707 245.062633,118.473737 244.101045,117.926765 L232.449735,70 L225,73.2365664 L238.858379,119.577682 C238.037446,121.307744 238.627713,123.384395 240.232335,124.411475 C241.836958,125.438555 243.948743,125.091423 245.14791,123.603459 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.810828,27.3044622 C234.952425,26.4009556 233.740633,25.9266728 232.501519,26.0092333 C231.262405,26.0917938 230.123254,26.7227167 229.390588,27.7322341 L211,29.8580057 L213.797593,37 L230.52274,33.848388 C232.328373,35.0005173 234.704511,34.6108174 236.053642,32.9412893 C237.402772,31.2717612 237.298457,28.8501159 235.810828,27.3044622 L235.810828,27.3044622 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,119.466038 L213.09455,179 L223.169321,176.967363 C223.169321,176.967363 221.687718,133.610177 226.725126,128.383347 C231.762534,123.156517 220.245997,114 220.245997,114 L205,119.466038 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.145844,103.028773 L205.477788,108.479625 C205.477788,108.479625 177.233759,96.8513989 177.233759,115.384037 C177.233759,133.916676 175.6175,146.493662 175.032925,147.362368 C174.448351,148.231074 181.795947,150.485252 185.303482,149.906099 C185.303482,149.906099 189.630639,120.028585 189.338343,118.291158 C189.338343,118.291158 217.04447,131.748712 222.305772,130.590428 C227.567073,129.432144 228.810086,125.331809 229.686957,123.01523 C230.563827,120.698651 229.320151,102.301993 229.320151,102.301993 L211.783176,97 L209.145844,103.028773 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.054743,70 L208.028627,68.760937 C208.028627,68.760937 196.536121,42.7406277 201.051031,35.7192741 C205.565941,28.6979205 225.267387,27.6653698 225.883063,28.0783872 C226.498739,28.4914046 224.412505,33.8537912 225.849057,36.3319281 C225.849057,36.3319281 210.587209,39.6615159 209.561083,40.0745369 C208.534956,40.4875579 217.468901,55.7507733 217.468901,55.7507733 L216.442789,65.043737 L209.054743,70 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.158762,57.4493853 C230.158762,57.4493853 219.317524,58.6917305 218.900538,58.6917305 C218.483552,58.6917305 218.27509,56 218.27509,56 L208.684741,69.0445363 C208.684741,69.0445363 203.959888,106.888328 205.210803,106.267157 C206.461717,105.645986 229.53331,109.213432 229.741802,107.556985 C229.950293,105.900538 229.53331,97.6182885 230.158777,97.2041722 C230.784243,96.7900559 241,71.1151032 241,71.1151032 C241,71.1151032 239.957573,65.7316422 236.413317,63.8681334 C232.869061,62.0046246 230.158762,57.4493853 230.158762,57.4493853 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.655936,67 L240.966595,70.4967315 C240.966595,70.4967315 245.885573,110.677495 243.195663,111.911637 C240.505753,113.145779 235.210298,112.994095 235.210298,112.994095 L230,93.9454162 L237.655936,67 Z",
    id: "Path",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    cx: 219.5,
    cy: 44.5,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.58853,46.7712073 C217.459693,44.7702901 214.962847,44.7017301 212.979617,44.6827847 C210.996386,44.6638393 208.625315,44.7354166 207.503133,43.0820987 C206.761528,41.9894765 206.903183,40.4726243 207.515856,39.3011811 C208.12853,38.1297379 209.1363,37.2287637 210.127733,36.3620089 C212.687377,34.1242686 215.325409,31.9042866 218.398476,30.4719849 C221.471543,29.0396833 225.072755,28.4609426 228.259839,29.6107134 C232.174913,31.0230995 237.467382,38.2935798 237.924403,42.4707117 C238.381423,46.6478436 236.730234,50.9061081 233.946869,54.0275383 C231.163505,57.1489685 224.792904,55.8895533 220.783778,57 C223.221103,53.5124145 221.614556,47.1753747 217.710006,45.5467611 L217.58853,46.7712073 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#05203B",
    cx: 132,
    cy: 147,
    r: 23
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.529739,122 C110.006766,122 104.094549,118.189469 101.440672,112.273838 L64.8833784,30.5420498 C61.5836557,23.1648834 62.6758773,14.5796588 67.7195675,8.24866105 C72.7632578,1.91766331 80.926795,-1.11523004 88.9179541,0.373098782 C96.9091131,1.86142761 103.410283,7.62557763 105.799645,15.3409586 L132.271546,100.820099 C133.808436,105.781757 132.883638,111.173032 129.779145,115.349993 C126.674653,119.526954 121.758504,121.99442 116.529754,122 L116.529739,122 Z",
    id: "Path",
    fill: "#05203B"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustCaution);
export default __webpack_public_path__ + "static/media/illust-caution.8688d4d7db935fd4b533f8845c375301.svg";
export { ForwardRef as ReactComponent };